function NotFound() {
	return ( <h1>not found</h1> );
}

export default NotFound;